const blog = {
  getlist: 'blog/getlist',
  add: 'blog/add',
  update: 'blog/update',
  remove: 'blog/remove',
  get: 'blog/get',
  getall: 'blog/getall',
}
export default blog
